import RequestStatusChart from './RequestStatusChart';

export default RequestStatusChart;
